/**
 * 哪些角色對哪個 resource 有 list 權限。
 *
 * 對照 apps/server/src/lib/auth/permissions.ts 的角色定義，不是照 subMenu 抄 ——
 * 決定會不會拿到 403 的是後端這張表。角色字串是逗號分隔的，一個人可以有好幾個。
 */
export const LIST_ROLES: Record<string, string[]> = {
  employee: ["owner", "admin", "member"],
  partner: [
    "owner",
    "admin",
    "member",
    "project",
    "purchase",
    "purchaseManager",
  ],
  project: ["owner", "admin", "project", "finance"],
  purchase: ["owner", "admin", "purchase", "purchaseManager"],
  inventory: ["owner", "admin", "purchase", "purchaseManager", "inventory"],
  finance: ["owner", "admin", "finance"],
};

/**
 * roles 是 null 代表「還沒問到角色」（沒登入、抓失敗、還在載入），
 * 這時一律放行 —— 問不到角色就把面板變成空的，比多一個 403 更糟。
 */
export const canList = (resource: string, roles: string[] | null): boolean => {
  if (!roles) return true;
  const allowed = LIST_ROLES[resource];
  if (!allowed) return true;
  return roles.some((r) => allowed.includes(r));
};

/** 把 better-auth 的 "member,inventory" 拆成角色陣列 */
export const parseRoles = (raw: unknown): string[] =>
  typeof raw === "string"
    ? [...new Set(raw.split(",").map((r) => r.trim()).filter(Boolean))]
    : [];
